import OrderCargoOrderAbandonedDownloadRequest, {
  OrderCargoOrderAbandonedDownloadRequestSortApiKey,
} from "../../../../../api/raily/order/cargo-order/abandoned/download/order-cargo-order-abandoned-download.request";
import AbandonedCargoOrder from "../../../../../types/abandoned-cargo-order";
import OrderCargoOrderAbandonedDownloadParams from "./order-cargo-order-abandoned-download-params";

const createOrder = (
  sortKey: AbandonedCargoOrder | null,
): OrderCargoOrderAbandonedDownloadRequestSortApiKey | null => {
  switch (sortKey) {
    case AbandonedCargoOrder.CREATED_AT_ASC:
      return OrderCargoOrderAbandonedDownloadRequestSortApiKey.CREATED_AT_ASC;
    case AbandonedCargoOrder.CREATED_AT_DESC:
      return OrderCargoOrderAbandonedDownloadRequestSortApiKey.CREATED_AT_DESC;
    case AbandonedCargoOrder.HUMAN_ID_ASC:
      return OrderCargoOrderAbandonedDownloadRequestSortApiKey.HUMAN_ID_ASC;
    case AbandonedCargoOrder.HUMAN_ID_DESC:
      return OrderCargoOrderAbandonedDownloadRequestSortApiKey.HUMAN_ID_DESC;
    case AbandonedCargoOrder.MODIFIED_AT_ASC:
      return OrderCargoOrderAbandonedDownloadRequestSortApiKey.MODIFIED_AT_ASC;
    case AbandonedCargoOrder.MODIFIED_AT_DESC:
      return OrderCargoOrderAbandonedDownloadRequestSortApiKey.MODIFIED_AT_DESC;
    default:
      return null;
  }
};

const create = (
  params: OrderCargoOrderAbandonedDownloadParams,
): OrderCargoOrderAbandonedDownloadRequest => {
  return {
    order: createOrder(params.order),
    address: params.address,
    client: params.client,
    creationEnd: params.creationEnd,
    creationStart: params.creationStart,
    dispatch: params.dispatch,
    endAddress: params.endAddress,
    externalId: params.externalId,
    humanId: params.humanId,
    midAddress: params.midAddress,
    passenger: params.passenger,
    publicStatus: params.publicStatus,
    startAddress: params.startAddress,
    startTimeSince: params.startTimeSince,
    startTimeTo: params.startTimeTo,
  };
};

const orderCargoOrderAbandonedDownloadParamsFactory = { create };

export default orderCargoOrderAbandonedDownloadParamsFactory;
